module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-300-light-ba8b581e495bf773dc9b7038c80470a8.woff";